import React, { useState } from "react";

const RelatorioAnalitico = () => {
  const [filtroTipo, setFiltroTipo] = useState("all");
  const [filtroCentro, setFiltroCentro] = useState("all");
  const [exportando] = useState(false);
  const [modalAberto, setModalAberto] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState(null);

  // Dados simulados de notas fiscais por item
  const notasFiscais = {
    "4.01.02.001.002": [
      {
        numero: "NF-2025-001",
        data: "15/01/2025",
        fornecedor: "Silva & Advogados Associados",
        descricao: "Consultoria jurídica empresarial - Janeiro",
        valor: 125000.5,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-018",
        data: "28/02/2025",
        fornecedor: "Silva & Advogados Associados",
        descricao: "Assessoria jurídica - Fevereiro",
        valor: 98503.25,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-035",
        data: "20/03/2025",
        fornecedor: "Escritório Pereira & Cia",
        descricao: "Consultoria jurídica trabalhista",
        valor: 85000.0,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-052",
        data: "18/04/2025",
        fornecedor: "Silva & Advogados Associados",
        descricao: "Assessoria jurídica - Abril",
        valor: 89500.23,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-068",
        data: "25/05/2025",
        fornecedor: "Advocacia Santos",
        descricao: "Consultoria em direito tributário",
        valor: 50000.0,
        situacao: "Pago",
      },
    ],
    "4.01.02.001.005": [
      {
        numero: "NF-2025-003",
        data: "10/01/2025",
        fornecedor: "Consultoria Estratégica Ltda",
        descricao: "Consultoria em gestão empresarial",
        valor: 75000.0,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-025",
        data: "15/02/2025",
        fornecedor: "RH Consultores",
        descricao: "Consultoria em recursos humanos",
        valor: 45500.32,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-041",
        data: "08/03/2025",
        fornecedor: "Tech Advisors",
        descricao: "Consultoria em tecnologia",
        valor: 89326.32,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-059",
        data: "22/04/2025",
        fornecedor: "Consultoria Estratégica Ltda",
        descricao: "Consultoria estratégica - Q2",
        valor: 82000.0,
        situacao: "Pago",
      },
    ],
    "4.01.02.006.004": [
      {
        numero: "NF-2025-012",
        data: "05/02/2025",
        fornecedor: "Agência Criativa Digital",
        descricao: "Campanha publicitária digital",
        valor: 18500.37,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-028",
        data: "18/03/2025",
        fornecedor: "Marketing Solutions",
        descricao: "Desenvolvimento de materiais promocionais",
        valor: 17380.0,
        situacao: "Pago",
      },
    ],
    "4.01.02.005.002": [
      {
        numero: "NF-2025-007",
        data: "31/01/2025",
        fornecedor: "CEMIG - Companhia Energética",
        descricao: "Energia elétrica - Janeiro",
        valor: 18250.45,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-021",
        data: "28/02/2025",
        fornecedor: "CEMIG - Companhia Energética",
        descricao: "Energia elétrica - Fevereiro",
        valor: 19800.3,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-038",
        data: "31/03/2025",
        fornecedor: "CEMIG - Companhia Energética",
        descricao: "Energia elétrica - Março",
        valor: 17564.2,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-055",
        data: "30/04/2025",
        fornecedor: "CEMIG - Companhia Energética",
        descricao: "Energia elétrica - Abril",
        valor: 16500.85,
        situacao: "Pago",
      },
      {
        numero: "NF-2025-072",
        data: "31/05/2025",
        fornecedor: "CEMIG - Companhia Energética",
        descricao: "Energia elétrica - Maio",
        valor: 19498.89,
        situacao: "Pago",
      },
    ],
  };

  // Dados do orçamento
  const dadosOrcamento = [
    // Administração e Mantença
    {
      centro: "administracao",
      centroNome: "ADMINISTRAÇÃO E MANTENÇA - MANTENEDORA",
      items: [
        {
          natureza: "Assessoria Jurídica / Advogados",
          codigo: "4.01.02.001.002",
          tipo: "D",
          orcado: 897889.0,
          realizado: 448003.98,
          empenhado: 0.0,
          execucao: 49.9,
        },
        {
          natureza: "Assessorias e Consultorias Diversas",
          codigo: "4.01.02.001.005",
          tipo: "D",
          orcado: 386000.0,
          realizado: 292826.64,
          empenhado: 0.0,
          execucao: 75.9,
        },
        {
          natureza: "Assessoria de Comunicação e Marketing",
          codigo: "4.01.02.006.004",
          tipo: "D",
          orcado: 217000.0,
          realizado: 35880.37,
          empenhado: 128536.0,
          execucao: 75.8,
        },
        {
          natureza: "Energia Elétrica",
          codigo: "4.01.02.005.002",
          tipo: "D",
          orcado: 194000.0,
          realizado: 91614.69,
          empenhado: 0.0,
          execucao: 47.2,
        },
        {
          natureza: "Outros Seguros",
          codigo: "4.01.02.009.010",
          tipo: "D",
          orcado: 159000.0,
          realizado: 14828.24,
          empenhado: 0.0,
          execucao: 9.3,
        },
        {
          natureza: "Imobilizado Veículos",
          codigo: "1.04.03.001.008",
          tipo: "I",
          orcado: 150000.0,
          realizado: 106990.0,
          empenhado: 0.0,
          execucao: 71.3,
        },
      ],
    },
    // RH - Mantenedora
    {
      centro: "rh",
      centroNome: "RH - MANTENEDORA",
      items: [
        {
          natureza: "Auxílio Refeição",
          codigo: "4.01.01.003.006",
          tipo: "D",
          orcado: 410512.0,
          realizado: 214024.0,
          empenhado: 0.0,
          execucao: 52.1,
        },
        {
          natureza: "Assistência Médica",
          codigo: "4.01.01.003.002",
          tipo: "D",
          orcado: 372114.56,
          realizado: 188878.66,
          empenhado: 0.0,
          execucao: 50.8,
        },
        {
          natureza: "Treinamento e Desenvolvimento",
          codigo: "4.01.01.004.001",
          tipo: "D",
          orcado: 368807.0,
          realizado: 213475.46,
          empenhado: 0.0,
          execucao: 57.9,
        },
        {
          natureza: "Medicina e Segurança do Trabalho",
          codigo: "4.01.02.001.009",
          tipo: "D",
          orcado: 171000.0,
          realizado: 80120.28,
          empenhado: 0.0,
          execucao: 46.8,
        },
      ],
    },
    // Coordenação TI
    {
      centro: "ti",
      centroNome: "COORDENAÇÃO TECNOLOGIA DA INFORMAÇÃO",
      items: [
        {
          natureza: "Imobilizado Equipamentos de Informática",
          codigo: "1.04.03.001.007",
          tipo: "I",
          orcado: 385000.0,
          realizado: 70005.86,
          empenhado: 0.0,
          execucao: 18.2,
        },
        {
          natureza: "Licença/Manutenção de Software",
          codigo: "4.01.02.004.001",
          tipo: "D",
          orcado: 200000.0,
          realizado: 104901.44,
          empenhado: 0.0,
          execucao: 52.5,
        },
        {
          natureza: "Serviços de Segurança - TI",
          codigo: "4.01.02.004.003",
          tipo: "D",
          orcado: 175000.0,
          realizado: 42163.1,
          empenhado: 0.0,
          execucao: 24.1,
        },
        {
          natureza: "Link de Dados e Internet",
          codigo: "4.01.02.005.005",
          tipo: "D",
          orcado: 125000.0,
          realizado: 32640.24,
          empenhado: 0.0,
          execucao: 26.1,
        },
      ],
    },
    // Projeto Meninas em Campo
    {
      centro: "meninas",
      centroNome: "PROJETO MENINAS EM CAMPO",
      items: [
        {
          natureza: "Receita Lei de Incentivo",
          codigo: "3.05.02.001.008",
          tipo: "R",
          orcado: 1545840.93,
          realizado: 0.0,
          empenhado: 0.0,
          execucao: 0.0,
        },
        {
          natureza: "Alimentação Lanches e Mantimentos",
          codigo: "4.01.02.009.001",
          tipo: "D",
          orcado: 296217.0,
          realizado: 21628.5,
          empenhado: 262.5,
          execucao: 7.4,
        },
        {
          natureza: "Serviços de Saúde",
          codigo: "4.01.02.001.015",
          tipo: "D",
          orcado: 24000.0,
          realizado: 0.0,
          empenhado: 0.0,
          execucao: 0.0,
        },
        {
          natureza: "Outros Serviços Prestados por Terceiros",
          codigo: "4.01.02.001.999",
          tipo: "D",
          orcado: 12750.0,
          realizado: 6890.0,
          empenhado: 0.0,
          execucao: 54.0,
        },
      ],
    },
    // Outros Centros
    {
      centro: "outros",
      centroNome: "OUTROS CENTROS DE CUSTO (CONSOLIDADO)",
      items: [
        {
          natureza: "Superintendência",
          codigo: "1.03.01.01.002",
          tipo: "D",
          orcado: 82100.0,
          realizado: 0.0,
          empenhado: 0.0,
          execucao: 0.0,
        },
        {
          natureza: "Coordenação Geral Contábil",
          codigo: "1.03.01.07.001",
          tipo: "D",
          orcado: 15500.0,
          realizado: 2747.52,
          empenhado: 0.0,
          execucao: 17.7,
        },
        {
          natureza: "Outros Centros (14 unidades)",
          codigo: "Diversos",
          tipo: "D/I",
          orcado: 48572.1,
          realizado: 71352.48,
          empenhado: 363.0,
          execucao: 147.6,
        },
      ],
    },
  ];

  // Função para exportar para PDF
  const exportarPDF = async () => {
    alert(
      "📄 Função de exportação para PDF será implementada após instalação das bibliotecas jsPDF."
    );
  };

  // Função para formatar valores monetários
  const formatMoney = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  // Função para obter classe de status da execução
  const getStatusClass = (execucao) => {
    if (execucao >= 60) return "text-danger fw-bold"; // ALTO - Vermelho
    if (execucao >= 30) return "text-warning fw-bold"; // MÉDIO - Amarelo
    return "text-success fw-bold"; // BAIXO - Verde
  };

  // Função para obter status em texto
  const getStatusText = (execucao) => {
    if (execucao >= 60) return "ALTO";
    if (execucao >= 30) return "MÉDIO";
    if (execucao === 0) return "PENDENTE";
    if (execucao > 100) return "EXCESSO";
    return "BAIXO";
  };

  // Função para abrir modal com detalhes das notas fiscais
  const abrirDetalheNotas = (item) => {
    setItemSelecionado(item);
    setModalAberto(true);
  };

  // Função para fechar modal
  const fecharModal = () => {
    setModalAberto(false);
    setItemSelecionado(null);
  };

  // Função para filtrar dados
  const dadosFiltrados = dadosOrcamento
    .filter((grupo) => {
      if (filtroCentro !== "all" && grupo.centro !== filtroCentro) {
        return false;
      }

      if (filtroTipo !== "all") {
        const temItemsFiltrados = grupo.items.some(
          (item) =>
            item.tipo === filtroTipo ||
            (filtroTipo === "D" && item.tipo === "D/I")
        );
        return temItemsFiltrados;
      }

      return true;
    })
    .map((grupo) => ({
      ...grupo,
      items: grupo.items.filter(
        (item) =>
          filtroTipo === "all" ||
          item.tipo === filtroTipo ||
          (filtroTipo === "D" && item.tipo === "D/I")
      ),
    }));

  // Função para resetar filtros
  const resetarFiltros = () => {
    setFiltroTipo("all");
    setFiltroCentro("all");
  };

  // Calcular totais
  const totais = {
    orcado: 22531044.93,
    realizado: 2666874.49,
    empenhado: 157551.69,
    disponivel: 19706618.75,
  };

  return (
    <div className="container-fluid py-4">
      {/* Cabeçalho */}
      <div className="row mb-4">
        <div className="col-12 text-center">
          <div className="bg-primary text-white p-4 rounded">
            <h1 className="display-6 fw-bold mb-2">
              RELATÓRIO ANALÍTICO - EXECUÇÃO ORÇAMENTÁRIA
            </h1>
            <p className="lead mb-1">
              Demonstrativo Detalhado por Centro de Custo e Natureza com
              Drill-down por Nota Fiscal
            </p>
            <small className="opacity-75">
              Período: Janeiro a Junho de 2025 | Gerado em: 17/06/2025
            </small>
          </div>
        </div>
      </div>

      {/* Filtros e Exportação */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">🔍 Filtros</h5>
              <button
                className="btn btn-danger btn-sm"
                onClick={exportarPDF}
                disabled={exportando}
              >
                {exportando ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Gerando PDF...
                  </>
                ) : (
                  <>📄 Exportar PDF</>
                )}
              </button>
            </div>
            <div className="card-body">
              <div className="row g-3 align-items-end">
                <div className="col-md-4">
                  <label htmlFor="tipoFilter" className="form-label fw-bold">
                    Filtrar por Tipo:
                  </label>
                  <select
                    id="tipoFilter"
                    className="form-select"
                    value={filtroTipo}
                    onChange={(e) => setFiltroTipo(e.target.value)}
                    disabled={exportando}
                  >
                    <option value="all">Todos os Tipos</option>
                    <option value="D">Despesas</option>
                    <option value="I">Investimentos</option>
                    <option value="R">Receitas</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="centroFilter" className="form-label fw-bold">
                    Filtrar por Centro:
                  </label>
                  <select
                    id="centroFilter"
                    className="form-select"
                    value={filtroCentro}
                    onChange={(e) => setFiltroCentro(e.target.value)}
                    disabled={exportando}
                  >
                    <option value="all">Todos os Centros</option>
                    <option value="administracao">
                      Administração e Mantença
                    </option>
                    <option value="rh">RH - Mantenedora</option>
                    <option value="ti">Coordenação TI</option>
                    <option value="meninas">Projeto Meninas em Campo</option>
                    <option value="outros">Outros Centros</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <button
                    className="btn btn-outline-primary w-100"
                    onClick={resetarFiltros}
                    disabled={exportando}
                  >
                    🔄 Limpar Filtros
                  </button>
                </div>
              </div>

              {/* Informações sobre filtros ativos */}
              {(filtroTipo !== "all" || filtroCentro !== "all") && (
                <div className="row mt-3">
                  <div className="col-12">
                    <div
                      className="alert alert-info alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <strong>Filtros Ativos:</strong>
                      {filtroTipo !== "all" && (
                        <span className="badge bg-primary ms-2">
                          Tipo:{" "}
                          {filtroTipo === "D"
                            ? "Despesas"
                            : filtroTipo === "I"
                            ? "Investimentos"
                            : "Receitas"}
                        </span>
                      )}
                      {filtroCentro !== "all" && (
                        <span className="badge bg-secondary ms-2">
                          Centro:{" "}
                          {filtroCentro === "administracao"
                            ? "Administração"
                            : filtroCentro === "rh"
                            ? "RH"
                            : filtroCentro === "ti"
                            ? "TI"
                            : filtroCentro === "meninas"
                            ? "Meninas em Campo"
                            : "Outros"}
                        </span>
                      )}
                      <button
                        type="button"
                        className="btn-close"
                        onClick={resetarFiltros}
                        aria-label="Close"
                      ></button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Resumo Executivo */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card">
            <div className="card-header bg-light">
              <h5 className="card-title mb-0">📊 Resumo Executivo</h5>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-3">
                  <div className="bg-light p-3 rounded border">
                    <small className="text-muted text-uppercase fw-bold">
                      Total Orçado
                    </small>
                    <div className="h4 fw-bold text-primary">
                      {formatMoney(totais.orcado)}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="bg-light p-3 rounded border">
                    <small className="text-muted text-uppercase fw-bold">
                      Total Realizado
                    </small>
                    <div className="h4 fw-bold text-primary">
                      {formatMoney(totais.realizado)}
                    </div>
                    <small className="text-success">11,8% do orçado</small>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="bg-light p-3 rounded border">
                    <small className="text-muted text-uppercase fw-bold">
                      Total Empenhado
                    </small>
                    <div className="h4 fw-bold text-primary">
                      {formatMoney(totais.empenhado)}
                    </div>
                    <small className="text-success">0,7% do orçado</small>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="bg-light p-3 rounded border">
                    <small className="text-muted text-uppercase fw-bold">
                      Saldo Disponível
                    </small>
                    <div className="h4 fw-bold text-primary">
                      {formatMoney(totais.disponivel)}
                    </div>
                    <small className="text-success">87,5% do orçado</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Instrução para drill-down */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="alert alert-info" role="alert">
            <strong>💡 Dica:</strong> Clique sobre os valores na coluna
            "REALIZADO (R$)" para ver o detalhamento das notas fiscais que
            compõem o valor.
          </div>
        </div>
      </div>

      {/* Tabela Principal */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card">
            <div className="card-header bg-primary text-white">
              <h5 className="card-title mb-0">
                📋 DETALHAMENTO POR CENTRO DE CUSTO E NATUREZA - ANALÍTICO
              </h5>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-dark">
                    <tr>
                      <th style={{ width: "25%" }}>
                        CENTRO DE CUSTO / NATUREZA
                      </th>
                      <th style={{ width: "8%" }}>CÓDIGO</th>
                      <th style={{ width: "5%" }}>TIPO</th>
                      <th style={{ width: "12%" }}>ORÇADO (R$)</th>
                      <th style={{ width: "12%" }}>REALIZADO (R$)</th>
                      <th style={{ width: "12%" }}>EMPENHADO (R$)</th>
                      <th style={{ width: "12%" }}>DISPONÍVEL (R$)</th>
                      <th style={{ width: "8%" }}>% EXEC.</th>
                      <th style={{ width: "6%" }}>STATUS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dadosFiltrados.map((grupo, groupIndex) => (
                      <React.Fragment key={groupIndex}>
                        {/* Cabeçalho do Grupo */}
                        <tr className="table-primary">
                          <td colSpan="9" className="fw-bold">
                            {grupo.centroNome}
                          </td>
                        </tr>
                        {/* Itens do Grupo */}
                        {grupo.items.map((item, itemIndex) => (
                          <tr
                            key={`${groupIndex}-${itemIndex}`}
                            className={itemIndex % 2 === 0 ? "table-light" : ""}
                          >
                            <td>{item.natureza}</td>
                            <td>
                              <small className="font-monospace">
                                {item.codigo}
                              </small>
                            </td>
                            <td>
                              <span className="badge bg-secondary">
                                {item.tipo}
                              </span>
                            </td>
                            <td className="text-end font-monospace">
                              {formatMoney(item.orcado)}
                            </td>
                            <td
                              className="text-end font-monospace"
                              style={{
                                cursor:
                                  item.realizado > 0 ? "pointer" : "default",
                              }}
                            >
                              {item.realizado > 0 ? (
                                <span
                                  className="text-primary text-decoration-underline fw-bold"
                                  onClick={() => abrirDetalheNotas(item)}
                                  title="Clique para ver detalhes das notas fiscais"
                                >
                                  {formatMoney(item.realizado)} 🔍
                                </span>
                              ) : (
                                formatMoney(item.realizado)
                              )}
                            </td>
                            <td className="text-end font-monospace">
                              {formatMoney(item.empenhado)}
                            </td>
                            <td className="text-end font-monospace">
                              {formatMoney(
                                item.orcado - item.realizado - item.empenhado
                              )}
                            </td>
                            <td className="text-center">
                              <span
                                className={`badge ${
                                  item.execucao >= 60
                                    ? "bg-danger"
                                    : item.execucao >= 30
                                    ? "bg-warning"
                                    : "bg-success"
                                }`}
                              >
                                {item.execucao.toFixed(1)}%
                              </span>
                            </td>
                            <td
                              className={`text-center ${getStatusClass(
                                item.execucao
                              )}`}
                            >
                              {getStatusText(item.execucao)}
                            </td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Totais Consolidados */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-primary">
            <div className="card-body bg-dark text-white">
              <div className="row text-center">
                <div className="col-md-2">
                  <strong>TOTAIS CONSOLIDADOS</strong>
                </div>
                <div className="col-md-2">
                  <div className="font-monospace fw-bold">
                    {formatMoney(totais.orcado)}
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="font-monospace fw-bold">
                    {formatMoney(totais.realizado)}
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="font-monospace fw-bold">
                    {formatMoney(totais.empenhado)}
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="font-monospace fw-bold">
                    {formatMoney(totais.disponivel)}
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="fw-bold">11,8%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notas e Observações */}
      <div className="row mb-4">
        <div className="col-md-8">
          <div className="alert alert-warning" role="alert">
            <h5 className="alert-heading">
              📝 NOTAS E OBSERVAÇÕES IMPORTANTES
            </h5>
            <hr />
            <ul className="mb-0">
              <li>
                <strong>Status de Execução:</strong> ALTO ≥ 60% (vermelho),
                MÉDIO 30-59% (amarelo), BAIXO &lt; 30% (verde)
              </li>
              <li>
                <strong>Saldo Disponível:</strong> 87,5% do orçamento ainda
                disponível para execução
              </li>
              <li>
                <strong>Relatório Analítico:</strong> Clique nos valores
                "Realizado" para ver as notas fiscais que compõem cada
                lançamento
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Modal para detalhes das notas fiscais */}
      {modalAberto && itemSelecionado && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">
                  📄 Detalhamento de Notas Fiscais - {itemSelecionado.natureza}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={fecharModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="alert alert-info">
                      <strong>Código:</strong> {itemSelecionado.codigo} |
                      <strong> Total Realizado:</strong>{" "}
                      {formatMoney(itemSelecionado.realizado)} |
                      <strong> Quantidade de NFs:</strong>{" "}
                      {notasFiscais[itemSelecionado.codigo]?.length || 0}
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead className="table-dark">
                      <tr>
                        <th>Número NF</th>
                        <th>Data</th>
                        <th>Fornecedor</th>
                        <th>Descrição</th>
                        <th className="text-end">Valor (R$)</th>
                        <th className="text-center">Situação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notasFiscais[itemSelecionado.codigo]?.map(
                        (nf, index) => (
                          <tr key={index}>
                            <td className="font-monospace fw-bold">
                              {nf.numero}
                            </td>
                            <td>{nf.data}</td>
                            <td>{nf.fornecedor}</td>
                            <td>{nf.descricao}</td>
                            <td className="text-end font-monospace fw-bold">
                              {formatMoney(nf.valor)}
                            </td>
                            <td className="text-center">
                              <span className="badge bg-success">
                                {nf.situacao}
                              </span>
                            </td>
                          </tr>
                        )
                      ) || (
                        <tr>
                          <td colSpan="6" className="text-center text-muted">
                            Nenhuma nota fiscal encontrada para este item
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {notasFiscais[itemSelecionado.codigo] && (
                      <tfoot className="table-secondary">
                        <tr>
                          <th colSpan="4" className="text-end">
                            Total das Notas Fiscais:
                          </th>
                          <th className="text-end font-monospace">
                            {formatMoney(
                              notasFiscais[itemSelecionado.codigo].reduce(
                                (total, nf) => total + nf.valor,
                                0
                              )
                            )}
                          </th>
                          <th></th>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={fecharModal}
                >
                  Fechar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    alert("Função de exportar detalhes será implementada")
                  }
                >
                  📄 Exportar Detalhes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Rodapé */}
      <div className="row">
        <div className="col-12">
          <div className="card border-0 bg-light">
            <div className="card-body text-center py-2">
              <small className="text-muted">
                <strong>
                  Sistema de Gestão Orçamentária - Relatório Analítico
                </strong>{" "}
                | Relatório gerado automaticamente
                <br />
                Data/Hora: 17/06/2025 às 14:30 | Responsável: Financeiro |
                Versão: 2.1 - Analítico
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatorioAnalitico;
